<template>
    <div :class="`dropdown-align-${align} dropdown`">
        <label for="dropdown">{{ fieldLabel }}</label>
        <div :class="['select-wrapper', { 'error': showError && isRequired && !selectedValue }]">
            <div class="custom-select">
                <select id="dropdown" name="dropdown" v-model="selectedValue" @change="emitSelection">
                    <option v-for="option in items" :key="option" :value="option">{{ option }}</option>
                </select>
                <span class="placeholder" v-if="!selectedValue">{{ placeholder || "Seçiniz..." }}</span>
                <span class="arrow">&#9662;</span>
            </div>
            <label class="alt-label" for="dropdown">{{ altLabel }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormDropDownList",
    props: {
        fieldLabel: {
            type: String,
            required: true,
        },
        altLabel: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            default: ''
        },
        align: {
            type: String,
            default: "top",
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default: () => ({ selected: "" }),
        },
        showError: {
            type: Boolean,
            default: false,
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            selectedValue: this.value.selected,
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.selectedValue = newValue.selected;
            },
            deep: true,
        },
        showError: {
            handler(newShowError) {
                if (newShowError) {
                    this.selectedValue = "";
                }
            },
        },
    },
    methods: {
        emitSelection() {
            this.$emit("input", {
                selected: this.selectedValue,
                fieldLabel: this.fieldLabel,
                altLabel: this.altLabel,
            });
            this.$emit("validate", {
                fieldId: this._uid,
                hasError: this.isRequired && (!this.selectedValue),
            });
        },
    },
    mounted() {
        this.emitSelection();
    },
};
</script>
<style lang="scss" scoped>
.dropdown-align-left {
    display: flex !important;

    > label {
        font-size: 14px !important;
        width: 150px !important;
    }

    .select-wrapper {
        width: 100%;
    }
}

.dropdown-align-right {
    display: flex !important;

    > label {
        font-size: 14px !important;
        width: 150px !important;
        text-align: right !important;
        margin-right: 5px !important;
    }

    .select-wrapper {
        width: 100%;
    }
}

.dropdown {
    width: 100%;
    max-width: 600px;
    margin: 10px auto;
    text-align: left;

    > label {
        display: block;
        font-size: 18px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #2c3e50;
    }

    .select-wrapper {
        display: flex;
        flex-direction: column;

        .custom-select {
            position: relative;
            width: 100%;

            select {
                width: 100%;
                padding: 8px 30px 8px 8px;
                font-size: 14px;
                border: 1px solid #ccd6dd;
                border-radius: 4px;
                box-sizing: border-box;
                margin-bottom: 4px;
                appearance: none;
                background-color: white;
                cursor: pointer;
            }

            .placeholder {
                position: absolute;
                left: 8px;
                top: 50%;
                transform: translateY(-50%);
                color: #8696a0;
                pointer-events: none;
            }

            .arrow {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                pointer-events: none;
            }
        }

        &.error .custom-select select {
            border: 1px solid red;
        }

        .error-message {
            color: red;
            font-size: 10px;
            position: absolute;
            bottom: -18px;
            left: 0;
        }
    }

    .alt-label {
        font-size: 12px;
        color: #8696a0;
        margin-top: 4px;
        font-weight: normal;
        display: block;
    }
}
</style>